<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div class="query-panel">
                    <el-form :inline="true" label-suffix=":">
                        <el-form-item label='来源'>
                            <el-select v-model="maskWordType" placeholder='请选择屏蔽字来源'>
                                <el-option v-for="item in tableOptions" :key="item.type" :label="item.str"
                                           :value="item.type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='屏蔽字'>
                            <el-input v-model="maskKey" placeholder='输入屏蔽字'></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button size="small" type="primary" @click.prevent="getMaskWords">搜索</el-button>
                            <el-button size="small" type="success" @click.prevent="addMaskWord">添加cjhwy2屏蔽字</el-button>
                            <el-button size="small" type="warning" @click.prevent="reloadMaskWords">重载全部屏蔽字</el-button>
                            <el-button size="small" type="danger" @click.prevent="refreshWords">强制检测屏蔽字OSS</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                    <el-table-column prop="word" label='屏蔽字'>
                    </el-table-column>
                    <el-table-column label='操作'>
                        <template slot-scope="scope">
                            <el-button  type="danger" v-if="scope.row.source === 0" icon="el-icon-delete" circle @click="delMaskWord(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                        layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>
            </section>
        </div>
    </el-card>
</template>

<script>
    import maskwordApi from '../../service/maskword_api'
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';

    export default {
        name: "logs",
        data() {
            return {
                title: this.$route.meta.title,
                maskKey: '',
                maskWordType : 'cjhwy2',
                tableOptions:[
                    {
                        type: 'cjhwy2',
                        str:'cjhwy2 - 超进化2自定义屏蔽字库'
                    },
                    {
                        type: 'common',
                        str:'common - OSS通用屏蔽库'
                    },
                    {
                        type: 'skipWords',
                        str:'skipWords - 无意义词库'
                    }
                ]
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        methods: {
            getMaskWords() {
                let self = this;
                if (self.maskWordType ==='common' &&"" === self.maskKey.trim()) {
                    self.$message({
                        type: 'error',
                        message: "请输入屏蔽字"
                    });
                    return;
                }

                maskwordApi.findByWord({
                    wordForm: {
                        word: self.maskKey.trim(),
                        channel: self.maskWordType
                    },
                    token: this.token
                }).then(res => {
                    console.log(res)

                    self.rawData = res;
                    self.totalRow = res.length;

                    self.tableRawData = res;
                    self.tableTotalRow = res.length;
                })
            },
            addMaskWord() {
                let self = this;
                if ("" === self.maskKey.trim()) {
                    self.$message({
                        type: 'error',
                        message: "请输入屏蔽字"
                    });
                    return;
                }
                this.$confirm('你准备添加屏蔽字:' + self.maskKey.trim() + ', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    maskwordApi.appendWord({
                        wordForm: {
                            word: self.maskKey.trim()
                        },
                        token: this.token
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消添加'
                    });
                });
            },
            delMaskWord(row) {
                let self = this;
                this.$confirm('你准备删除屏蔽字:' + row.word + ', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    maskwordApi.delWord({
                        wordForm: {
                            word: row.word
                        },
                        token: this.token
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        self.getMaskWords();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            reloadMaskWords() {
                //TODO 重载
            },
            refreshWords(){
                maskwordApi.refreshWord({
                    token: this.token
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '发送成功!'
                    });
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lang_dialog/mask_word.vue